export const convertBooleanStringToBoolean = (boolStr: string) => {
  return boolStr === 'true';
};
